import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from '../app/store';
import { useSelector } from "react-redux";

function PrivateRoutes() {
    const isSignIn = useSelector((state: RootState) => state.auth.isSignIn);
    return (
        isSignIn ? <Outlet /> : <Navigate to="/login" />
    );
}

export default PrivateRoutes;